import {
  Box,
  Button,
  Paper,
  Stack,
  Typography,
  Tabs,
  Tab,
  Card,
  Grid,
  MenuItem,
  FormHelperText,
  FormControl,
  InputLabel,
  Select
} from "@mui/material";
import { useEffect, useState, useContext, useMemo } from "react";
import { HiTemplate } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import { useParams } from "react-router-dom";
import { analiticsFilterApi } from "../../store/analytics/filters";
import { analyticsGraphApi } from "../../store/analytics/analyticsGraphDetail";
import { analyticsTableApi } from "../../store/analytics/analyticsList";
import PropTypes from 'prop-types';
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import HealthCheck from "./HealthCheck";
import ContentConsumptionNonGraded from "./ContentConsumptionNonGraded";
import CommunityEngagement from "./CommunityEngagement";
import AppErrors from "./AppErrors";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { classGlobalApi } from "../../store/class/classListGlobal";
import { subjectGlobalApi } from "../../store/subject/subjectListGlobal";
import apiRoutes from "../../store/apiConfigs";
import { AuthContext } from "../../context/AuthContext";
import { contentConsumptionGraphApi } from "../../store/analytics/contentConsumptionNonGraded";
import usePermission from "../../hooks/usePermission";
import PermissionGate from "../../components/PermissionGate";

const data = [
  {
    name: "January",
    uv: 4000,
    pv: 2400,
    nv: 2400,
    amt: 2400,
  },
  {
    name: "Fabruary",
    uv: 3000,
    pv: 1398,
    nv: 2400,
    amt: 2210,
  },
  {
    name: "March",
    uv: 2000,
    pv: 9800,
    nv: 4040,
    amt: 2290,
  },
  {
    name: "April",
    uv: 2780,
    pv: 3908,
    nv: 2400,
    amt: 2000,
  },
  {
    name: "May",
    uv: 1890,
    pv: 4800,
    nv: 2400,
    amt: 2181,
  },
  {
    name: "June",
    uv: 2390,
    pv: 3800,
    nv: 9090,
    amt: 2500,
  },
  {
    name: "July",
    uv: 3490,
    pv: 4300,
    nv: 2400,
    amt: 2100,
  },
  {
    name: "august",
    uv: 3490,
    pv: 4300,
    nv: 2400,
    amt: 2100,
  }, {
    name: "September",
    uv: 3490,
    pv: 4300,
    nv: 2400,
    amt: 2100,
  }, {
    name: "October",
    uv: 3490,
    pv: 4300,
    nv: 2400,
    amt: 2100,
  }, {
    name: "November",
    uv: 3490,
    pv: 4300,
    nv: 2400,
    amt: 2100,
  }, {
    name: "December",
    uv: 3490,
    pv: 4300,
    nv: 2400,
    amt: 2100,
  },
];
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
const nonGradedModules = [
  { name: "Courses", value: "course", permissionModule: "courses" },
  { name: "Podcasts", value: "podcast", permissionModule: "podcast" },
  { name: "Short Videos", value: "short_videos", permissionModule: "short_videos" },
  { name: "Quizzes", value: "quiz", permissionModule: "quizzes" },
  { name: "Webinars", value: "webinar", permissionModule: "webinar" },
]
const gradedModules = [
  { name: "Teaching Videos", value: "teaching_videos", permissionModule: "teaching_resources" },
  { name: "Lesson Plans", value: "lesson_plan", permissionModule: "lesson_plan" },
  { name: "Worksheets", value: "worksheet", permissionModule: "worksheet" },
]
const communityModules = [
  { name: "Impact Stories", value: "impact_stories" },
  { name: "PodCast", value: "podcast" },
  { name: "Sunday Polls", value: "sunday_polls" },
  { name: "Short Videos", value: "short_videos" },
  { name: "Quiz", value: "quiz" },
  { name: "Webinar", value: "webinar" },
  { name: "School Processes", value: "school_process" },
  { name: "Courses", value: "course" },
  { name: "Teaching Videos", value: "teaching_videos" },
  { name: "Learning material", value: "learning_material" },
  { name: "Project Based", value: "project_based" },
  { name: "Entry Exit", value: "entry_exit_questions" },
  { name: "Home Work", value: "home_work" },
]
const reportTypes = [
  { name: "User report", value: "user_report" },
  { name: "Content report", value: "content_report" },
  { name: "Content based user report", value: "user_content_report" },
  { name: "Content report (Channel)", value: "channel_content_report" },
  { name: "Content based user report (Channel)", value: "channel_user_content_report" },
  { name: "Quick Access report", value: "quick_access" },
]
const reportTypesChannel = [
  { name: "Content report (Channel)", value: "individual_channel_content_report", channel: true },
  { name: "Content based user report (Channel)", value: "individual_channel_user_content_report", channel: true },
  { name: "Quick Access report", value: "quick_access", channel: true },
]
CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function ChannelAnalyticsListing() {
  const analyticsFilter = useSelector((state) => state?.analyticsFilter);
  const { result: filterResult, filterLoading } = analyticsFilter;
  const analyticsGraph = useSelector((state) => state?.analyticsGraph);
  const { result: graphResult, graphLoading } = analyticsGraph;
  const contentConsumptionGraph = useSelector((state) => state?.contentConsumptionGraph);
  const { result: contentGraphResult } = contentConsumptionGraph || {};
  const auth = useContext(AuthContext);
  const { can, isSuperUser } = usePermission();
  const canViewContentConsumption = isSuperUser || can("analytics_dashboard", "read");
  const canViewBatchReports = isSuperUser || can("channel", "read");
  const allowedNonGradedModules = useMemo(() => nonGradedModules.filter(({ permissionModule }) => (
    isSuperUser || can(permissionModule, "analytics")
  )), [can, isSuperUser]);
  const allowedGradedModules = useMemo(() => gradedModules.filter(({ permissionModule }) => (
    isSuperUser || can(permissionModule, "analytics")
  )), [can, isSuperUser]);

  const [error, setError] = useState(null);
  const { result: classList, loading: classLoading } = useSelector((state) => state?.classGlobal);
  const { result: subjectList, loading: subjectLoading } = useSelector((state) => state?.subjectGlobal);

  const schema = yup
    .object({})
    .required();
  const schemaEdit = yup
    .object({})
    .required();
  const params = useParams();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(params.id ? schemaEdit : schema),
    defaultValues: {},
  });
  const [value, setValue] = useState(4);
  const [cat, setCat] = useState();
  const [classs, setClasss] = useState();
  const [subject, setSubject] = useState();
  const [state, setState] = useState();
  const [module, setModule] = useState("learningmaterial");
  const [nonGradedModule, setNonGradedModule] = useState("short_videos");
  const [communityModule, setCommunityModule] = useState("short_videos");
  const [isDownload, setIsDownload] = useState(false)
  const [reportType, setReportType] = useState("user_report");
  const [monthDaily, setMonthDaily] = useState("monthly");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [region, setRegion] = useState();
  const [contentType, setContentType] = useState("non-graded");
  const categories = useSelector((state) => state?.categories);
  const toMaxDate = startDate
    ? (dayjs(startDate).add(1, 'month').isAfter(dayjs()) ? dayjs() : dayjs(startDate).add(1, 'month'))
    : dayjs();
  useEffect(() => {
    const availableModules = contentType === "graded" ? allowedGradedModules : allowedNonGradedModules;
    if (availableModules.length > 0 && !availableModules.some(({ value }) => value === nonGradedModule)) {
      setNonGradedModule(availableModules[0].value);
    }
    if (contentType === "graded" && allowedGradedModules.length === 0 && allowedNonGradedModules.length > 0) {
      setContentType("non-graded");
      setNonGradedModule(allowedNonGradedModules[0].value);
    }
    if (contentType === "non-graded" && allowedNonGradedModules.length === 0 && allowedGradedModules.length > 0) {
      setContentType("graded");
      setNonGradedModule(allowedGradedModules[0].value);
    }
  }, [allowedGradedModules, allowedNonGradedModules, contentType, nonGradedModule]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    if (value === 1 && !canViewContentConsumption) {
      return;
    }

    if (value === 4 && !canViewBatchReports) {
      return;
    }

    if (value === 3) {
      dispatch(analiticsFilterApi({ type: "city" }));
    } else {
      dispatch(analiticsFilterApi({
        type: "filters", params: {
          start_date: startDate,
          end_date: endDate
        }
      }));

    }
  }, [value, canViewContentConsumption, canViewBatchReports, dispatch, startDate, endDate])

  useEffect(() => {
    if (value === 1 && !canViewContentConsumption) {
      return;
    }

    if (value === 4 && !canViewBatchReports) {
      return;
    }

    switch (value) {
      case 0:
        dispatch(analyticsGraphApi({
          type: "health",
          params: {
            analytics_type: "health_check",
            city: region,
            region: state,
            frequency: monthDaily,
            start_date: startDate,
            end_date: endDate
          }
        }));
        break;
      case 1:
        dispatch(contentConsumptionGraphApi({
          params: {
            graph_type: "module_overview",
            period: monthDaily,
            content_type: nonGradedModule,
            start_date: startDate,
            end_date: endDate,
            city: region,
            state
          }
        }));
        break;
      case 2:
        dispatch(analyticsGraphApi({
          type: "health",
          params: {
            analytics_type: "content_consumption_graded",
            module: module,
            class: classs,
            subject: subject,
            start_date: startDate,
            end_date: endDate
          }
        }));
        break;
      case 3:
        dispatch(analyticsGraphApi({
          type: "community",
          params: {
            analytics_type: "google_analytics",
            module: communityModule,
            city: region,
            region: state,
            frequency: monthDaily,
            start_date: startDate,
            end_date: endDate
          }
        }));
        break;
      default:
        dispatch(analyticsGraphApi({
          type: "health",
          params: {
            analytics_type: "health_check",
            city: region,
            region: state,
            frequency: monthDaily
          }
        }));
        dispatch(analyticsTableApi({
          type: "health",
          params: {
            analytics_type: "registration_stats",
            city: region,
            region: state,
            frequency: monthDaily
          }
        }));
    }

  }, [dispatch,
    cat,
    state,
    monthDaily,
    region,
    value,
    module,
    classs,
    subject,
    startDate,
    endDate,
    nonGradedModule,
    communityModule,
    canViewContentConsumption,
    canViewBatchReports
  ]);

  useEffect(() => {
    if (value === 1 && !canViewContentConsumption) {
      setValue(canViewBatchReports ? 4 : false);
    } else if (value === 4 && !canViewBatchReports) {
      setValue(canViewContentConsumption ? 1 : false);
    }
  }, [value, canViewContentConsumption, canViewBatchReports]);
  const handleClear = async () => {
    setClasss()
    setSubject()
    setState()
    setModule("learningmaterial")
    setMonthDaily("monthly")
    setStartDate()
    setEndDate()
    setRegion()
    setCommunityModule("short_videos")
    setContentType("non-graded")
    setNonGradedModule(allowedNonGradedModules[0]?.value)
  };
  const handleApiCall = async () => {
    try {
      let apiUrl;
      if (reportType === "quick_access") {
        apiUrl = `${process.env.REACT_APP_BASE_URL}${apiRoutes.quickAccessReport}?download=csv`;
      } else {
        let query = {
          report: reportType
        };
        const params = new URLSearchParams(query);
        const queryString = params.toString();
        apiUrl = `${process.env.REACT_APP_BASE_URL}${apiRoutes.adminAction("report-download", 1)}?${queryString}`;
      }

      setIsDownload(true);
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        setIsDownload(false);
        throw new Error('Network response was not ok');
      }

      const blob = await response.json();
      // Create a URL for the file
      const url = blob.result;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `batchreport_${reportType}_${new Date().getTime()}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setIsDownload(false);
    } catch (error) {
      console.error('Error exporting data:', error);
      setIsDownload(false);
      alert('Failed to export data.');
    }
  };

  useEffect(() => {
    dispatch(classGlobalApi());
    dispatch(subjectGlobalApi());
  }, [dispatch])
  return (
    <>
      <Appbar />
      <Drawer />
      <Body>

        <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
          <HiTemplate size={30} />
          <Typography>Channel Analytics Dashboard</Typography>
        </Stack>

        <Paper elevation={0}>
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="analytics tabs" variant="scrollable" scrollButtons
                allowScrollButtonsMobile >
                {canViewContentConsumption && <Tab label="Content Consumption" {...a11yProps(1)} value={1} />}
                {canViewBatchReports && <Tab label="Batch Reports" {...a11yProps(4)} value={4} />}
              </Tabs>
            </Box>
            <PermissionGate module="analytics_dashboard" action="read">
              <CustomTabPanel value={value} index={1}>
                <form id="outer_form_content_consumption">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <Card><Stack direction="row" spacing={2}><FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>Monthly/Daily</InputLabel>
                        <Select {...register("monthDaily")} label="Monthly/Daily" value={monthDaily || null} notched
                          error={errors?.monthDaily?.message} onChange={(e) => setMonthDaily(e.target.value)} disabled={!!startDate || !!endDate}>
                          {[{ label: "Monthly", value: "monthly" }, { label: "Daily", value: "daily" }].map((item) => (
                            <MenuItem value={item.value} key={item.value}>{item.label}</MenuItem>
                          ))}
                        </Select>
                        <FormHelperText error>{errors?.monthDaily?.message}</FormHelperText>
                      </FormControl></Stack></Card>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <Card><Stack direction="row" spacing={2}><FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>Content Type</InputLabel>
                        <Select label="Content Type" value={contentType} notched onChange={(e) => {
                          const nextContentType = e.target.value;
                          const nextModules = nextContentType === "graded" ? allowedGradedModules : allowedNonGradedModules;
                          setContentType(nextContentType);
                          setNonGradedModule(nextModules[0]?.value);
                        }}>
                          {allowedNonGradedModules.length > 0 && <MenuItem value="non-graded">Non-Graded</MenuItem>}
                          {allowedGradedModules.length > 0 && <MenuItem value="graded">Graded</MenuItem>}
                        </Select>
                      </FormControl></Stack></Card>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <Card><Stack direction="row" spacing={2}><FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>Type</InputLabel>
                        <Select {...register("module")} label="Type" value={nonGradedModule || null} notched onChange={(e) => setNonGradedModule(e.target.value)}>
                          {(contentType === "graded" ? allowedGradedModules : allowedNonGradedModules).map(({ name, value }) => <MenuItem value={value} key={value}>{name}</MenuItem>)}
                        </Select>
                      </FormControl></Stack></Card>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <Card><Stack direction="row" spacing={2}><FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>State</InputLabel>
                        <Select {...register("state")} label="State" value={state || null} notched onChange={(e) => setState(e.target.value)}>
                          {Object.keys(filterResult || {}).map((title) => <MenuItem value={title} key={title}>{title}</MenuItem>)}
                        </Select>
                        <FormHelperText error>{errors?.state?.message}</FormHelperText>
                      </FormControl></Stack></Card>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <Card><Stack direction="row" spacing={2}><FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>Region*</InputLabel>
                        <Select {...register("region")} label="Region" value={region || null} notched onChange={(e) => setRegion(e.target.value)}>
                          {state && Object.values(filterResult?.[state] || {}).sort().map((title) => <MenuItem value={title} key={title}>{title}</MenuItem>)}
                        </Select>
                        <FormHelperText error>{errors?.region?.message}</FormHelperText>
                      </FormControl></Stack></Card>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <Card><Stack direction="row" spacing={2}><FormControl variant="outlined" fullWidth>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker {...register("startTime")} label="From*" value={startDate ? dayjs(startDate) : null}
                            minDate={endDate ? dayjs(endDate).subtract(1, "month") : null} maxDate={endDate ? dayjs(endDate) : dayjs()}
                            disableFuture onError={(newError) => setError(newError)}
                            onChange={(newValue) => setStartDate(newValue ? dayjs(newValue).format("YYYY-MM-DD") : undefined)} />
                        </LocalizationProvider>
                      </FormControl></Stack></Card>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <Card><Stack direction="row" spacing={2}><FormControl variant="outlined" fullWidth>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker {...register("endDate")} label="To*" value={endDate ? dayjs(endDate) : null}
                            minDate={startDate ? dayjs(startDate) : null} maxDate={toMaxDate} disableFuture
                            onError={(newError) => setError(newError)}
                            onChange={(newValue) => setEndDate(newValue ? dayjs(newValue).format("YYYY-MM-DD") : undefined)} />
                        </LocalizationProvider>
                      </FormControl></Stack></Card>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <Card><Stack direction="row" spacing={2}><FormControl variant="outlined" fullWidth>
                        <Button sx={{ minHeight: "41px" }} type="button" onClick={handleClear} variant="outlined">Clear</Button>
                      </FormControl></Stack></Card>
                    </Grid>
                  </Grid>
                </form>
                <ContentConsumptionNonGraded graphData={contentGraphResult} type={monthDaily} module={nonGradedModule}
                  startDate={startDate} endDate={endDate} region={region} state={state} />
              </CustomTabPanel>
            </PermissionGate>
            <PermissionGate module="channel" action="read">
              <CustomTabPanel value={value} index={4}>
                <form id="outer_form_batch_report">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <Card>
                        <Stack direction="row" spacing={2}>
                          <FormControl variant="outlined" fullWidth>
                            <InputLabel shrink>Report Type</InputLabel>
                            <Select
                              {...register("reportType")}
                              label="Report Type"
                              id="outlined-adornment-module"
                              value={reportType ? reportType : null}
                              notched
                              defaultValue={reportTypes[0].value}
                              onChange={(e) => setReportType(e.target.value)}
                            >
                              {auth?.userData?.is_subadmin ? reportTypesChannel?.map(({ name, value }, index) => (
                                <MenuItem value={value} key={index}>
                                  {name}
                                </MenuItem>
                              )) : reportTypes?.map(({ name, value }, index) => (
                                <MenuItem value={value} key={index}>
                                  {name}
                                </MenuItem>
                              ))}
                            </Select>

                            <FormHelperText error>
                              {errors?.reportType?.message}
                            </FormHelperText>
                          </FormControl>
                        </Stack>
                      </Card>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <Card>
                        <Stack direction="row" spacing={2}>
                          <FormControl variant="outlined" fullWidth>
                            <Button sx={{
                              minHeight: "41px"
                            }} type="button" onClick={() => handleApiCall()} variant="outlined">Download Report</Button>
                          </FormControl>
                        </Stack>
                      </Card>
                    </Grid>
                  </Grid>
                </form>
              </CustomTabPanel>
            </PermissionGate>
          </Box>
        </Paper>

      </Body>
    </>
  );
}
